<!--
 * @Author: fengzhongmei
 * @Date: 2020-07-23 15:03:12
 * @LastEditors: fengzhongmei
 * @LastEditTime: 2020-08-13 16:04:00
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
-->
<template>
    <div class="module">
        <helpinfo :helpData="helpData" />
        <div class="module-container table-container">
            <rcTable ref="rcTable"
                     :tableAttr="tableAttr">
                <div slot="tootipL">
                    <Button slot="tootipL"
                            @click="refreshTable">
                        <i class="icon-refresh-o-2"></i>
                    </Button>
                    <Button @click="importSSH"
                            :disabled="!this.hasPermission('CB011704')"
                            type="primary">
                        <i class="icon-Import-o"></i>&nbsp;<span>{{$i18n.t('导入')}}</span></Button>
                    <Button @click="createSSH"
                            :disabled="!this.hasPermission('CB011701')"
                            type="primary">
                        <i class="icon-plus-o-1"></i><span>{{$i18n.t('创建')}}</span></Button>
                </div>
            </rcTable>
        </div>
        <Modal v-model="modalImport"
               class="ssh-key-modal"
               @on-cancel="cancelImport"
               :mask-closable="false"
               :title="$t('导入密钥对')">
            <Form ref="formImport"
                  :model="formData"
                  class="form-con"
                  :rules="rules"
                  :label-width="120">
                <FormItem prop="keypairName"
                          :label="$t('密钥对名称')+'：'">
                    <Input type="text"
                           class="form-item"
                           v-model="formData.keypairName"
                           :placeholder="$t('只能输入英文，数字，下划线')">
                    </Input>
                </FormItem>
                <FormItem :label="$t('描述')+'：'">
                    <Input type="textarea"
                           class="form-item"
                           :autosize="{minRows: 2,maxRows: 5}"
                           v-model="formData.description"
                           :placeholder="$t('描述')">
                    </Input>
                </FormItem>
                <FormItem prop="publicKey"
                          :label="$t('公钥')+'：'">
                    <Input type="textarea"
                           class="form-item"
                           v-model="formData.publicKey"
                           :autosize="{minRows: 4,maxRows: 8}"
                           :placeholder="$t('公钥')">
                    </Input>
                </FormItem>
                <FormItem prop="privateKey"
                          :label="$t('私钥')+'：'">
                    <Input type="textarea"
                           class="form-item"
                           v-model="formData.privateKey"
                           :autosize="{minRows: 4,maxRows: 10}"
                           :placeholder="$t('私钥')">
                    </Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelImport"
                        class="ivu-btn-text">{{$t('取消')}}</Button>
                <Button type="primary"
                        @click="saveImport"
                        :loading="loading">
                    <span v-show="!loading">{{$t('导入')}}</span>
                    <span v-show="loading">{{$t('导入中')}}</span>
                </Button>
            </div>
        </Modal>
        <Modal v-model="modalssh"
               class="ssh-key-modal"
               @on-cancel="modalCancel"
               :mask-closable="false"
               :title="modalType === 'add' ? $t('创建密钥对') : $t('编辑密钥对')">
            <Form ref="form"
                  class="form-con"
                  :model="formData"
                  :rules="rules"
                  :label-width="120">
                <FormItem prop="keypairName"
                          :label="$t('密钥对名称')+'：'">
                    <Input type="text"
                           class="form-item"
                           v-model="formData.keypairName"
                           :placeholder="$t('只能输入英文，数字，下划线')">
                    </Input>
                </FormItem>
                <FormItem :label="$t('描述')+'：'">
                    <Input type="textarea"
                           class="form-item"
                           :autosize="{minRows: 4,maxRows: 10}"
                           v-model="formData.description"
                           :placeholder="$t('描述')">
                    </Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="modalCancel"
                        class="ivu-btn-text">{{$t('取消')}}</Button>
                <Button type="primary"
                        @click="modalSave"
                        :loading="loading">
                    <span v-show="!loading">{{modalType === 'add' ? $t('创建') : $t('保存')}}</span>
                    <span v-show="loading">{{modalType === 'add' ? $t('创建中'): $t('保存中')}}</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import API from '@/service/api.js'
import helpinfo from '@c/basic/helpinfo'
import rcTable from '@c/basic/rcTable'
import { isKeypair } from '@/service/validator.js'
export default {
    name: 'ssh',
    components: {
        rcTable,
        helpinfo
    },
    props: ['origin', 'tableName'], // origin表示的是哪个页面引用的该组件
    data () {
        return {
            helpData: {
                modelName: this.$t('密钥对'),
                showBack: false
            },
            modalType: 0,
            modalImport: false,
            modalssh: false,
            loading: false,
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_ENV_KEYPAIRS_ID, false),
                    params: {}
                },
                searchShow: true,
                tableSearchKey: this.tableName || '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: this.tableName || '', // 当作列选择的key存在
                columnsChooseShow: true,
                searchColumns: [
                    {
                        key: 'keypairNameLike',
                        title: this.$i18n.t('名称'),
                        searchDefaultValue: ''
                    }
                ],
                referenceVal: 1203,
                columns: [
                    {
                        title: this.$i18n.t('名称'),
                        key: 'keypairName',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => {
                            return h('div', {
                                class: 'tbl-operate'
                            }, [
                                h(this.hasPermission('CB011702') ? 'a' : 'span', {
                                    on: { click: () => this.hasPermission('CB011702') && this.getDetail(params.row.id) }
                                }, params.row.keypairName)
                            ])
                        }
                    }, {
                        title: this.$i18n.t('指纹'),
                        key: 'fingerprint',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 300,
                        render: (h, params) => {
                            return h('span', {
                                attrs: {
                                    title: params.row.fingerprint
                                }
                            }, params.row.fingerprint)
                        }
                    },
                    {
                        title: this.$i18n.t('创建时间'),
                        key: 'createdDt',
                        sortable: true,
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 170
                    }, {
                        title: this.$i18n.t('描述'),
                        key: 'description',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 170
                    }, {
                        title: this.$i18n.t('操作'),
                        width: 150,
                        render: (h, params) => {
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, [
                                this.hasPermission('CB011702') && h('a', {
                                    class: { 'disabled-per': !this.hasPermission('CB011702') },
                                    on: { click: () => this.hasPermission('CB011702') && this.getDetail(params.row.id) }
                                }, this.$i18n.t('详情')),
                                this.hasPermission('CB011703') && h('a', {
                                    class: { 'disabled-per': !this.hasPermission('CB011703') },
                                    on: { click: () => this.hasPermission('CB011703') && this.editFun(params.row.id) }
                                }, this.$i18n.t('编辑')),
                                this.hasPermission('CB011705') && h('a', {
                                    class: { 'disabled-per': !this.hasPermission('CB011705') },
                                    on: { click: () => this.hasPermission('CB011705') && this.deleteFun(params.row.id) }
                                }, this.$i18n.t('删除'))
                            ])
                        }
                    }
                ]
            },
            editDatas: {},
            formData: {
                keypairName: '',
                description: '',
                privateKey: '',
                publicKey: ''
            },
            rules: {
                keypairName: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    { validator: isKeypair, trigger: 'blur' }
                ],
                publicKey: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' }
                ],
                privateKey: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        // 查询保持
        if (this.tableName && sessionStorage.ts_list && JSON.parse(sessionStorage.ts_list)[this.tableName]) {
            this.tableAttr.searchDefaultValueList = JSON.parse(sessionStorage.ts_list)[this.tableName]
        }
    },
    methods: {
        // 刷新
        refreshTable () {
            this.$refs.rcTable.refreshTable()
        },
        // 详情
        getDetail (id) {
            this.$router.push({ path: `/mgt/ssh/deatil/${id}`, query: { keyHide: true } })
        },
        // 创建
        createSSH () {
            if (!this.hasPermission('CB011701')) {
                return
            }
            this.modalType = 'add'
            this.modalssh = true
        },
        // 删除
        deleteFun (id) {
            this.$Modal.confirm({
                title: this.$t('删除'),
                content: this.$t('您确认要删除该密钥对吗？'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(`${API.GET_ENV_KEYPAIRS_ID}/${id}`, false)).then(res => {
                        if (res) {
                            this.refreshTable()
                        }
                    })
                }
            })
        },
        // 点击编辑按钮
        editFun (id) {
            this.axios.get(this.urlFormat(`${API.GET_ENV_KEYPAIRS_ID}/${id}`, false)).then(res => {
                this.editDatas = res
                this.formData.keypairName = res.keypairName
                this.formData.description = res.description
                this.modalssh = true
                this.modalType = 'edit'
            })
        },
        // 关闭弹框
        modalCancel () {
            this.modalType = 0
            this.modalssh = false
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.formData.description = ''
                this.loading = false
            })
        },
        // 创建，编辑表单验证
        modalSave () {
            this.loading = true
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.modalType === 'add') {
                        this.createKeyFun()
                    } else if (this.modalType === 'edit') {
                        this.editKeyFun()
                    }
                } else {
                    this.loading = false
                }
            })
        },
        // 编辑提交请求
        editKeyFun () {
            this.editDatas.keypairName = this.formData.keypairName
            this.editDatas.description = this.formData.description
            this.axios.put(this.urlFormat(API.GET_ENV_KEYPAIRS_ID, false), this.editDatas).then(res => {
                if (res.code === 200 && res.status === true) {
                    this.modalCancel()
                    this.refreshTable()
                } else {
                    this.loading = false
                }
            })
        },
        // 创建提交请求
        createKeyFun () {
            const obj = {
                keypairName: this.formData.keypairName,
                description: this.formData.description
            }
            this.axios.post(this.urlFormat(API.GET_ENV_KEYPAIRS_ID, false), obj).then(res => {
                if (res.code === 200 && res.status === true) {
                    this.downloadPrivateKey(res, this.formData.keypairName)
                    this.modalCancel()
                    this.refreshTable()
                } else {
                    this.loading = false
                }
            }).catch(e => {
                this.loading = false
            })
        },
        // 下载
        downloadPrivateKey (res, name) {
            const href = this.urlFormat(`${API.EXPORT_SSH_KEYPAIRS}`, false) + '/' + res.data
            const [userSid] = [this.$store.state.user.currentUser.info.userSid, '', '']
            this.axios({
                method: 'get',
                url: href,
                headers: {
                    token: userSid
                },
                responseType: 'blob'
            }).then(res => {
                if (res) {
                    // 文件下载
                    const blob = new Blob([res], {
                        type: 'application/vnd.ms-excel'
                    })
                    let link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.setAttribute('download', name + '.pem')
                    link.click()
                    link = null
                }
            }).catch(e => {
                console.log(e)
            })
        },
        // 导入
        importSSH () {
            if (!this.hasPermission('CB011704')) {
                return
            }
            this.modalImport = true
        },
        // 保存导入
        saveImport () {
            this.loading = true
            this.$refs.formImport.validate((valid) => {
                if (valid) {
                    this.axios.post(this.urlFormat(API.POST_SSH_KEYPAIRS_inport, false), this.formData).then(res => {
                        if (res.code === 200 && res.status === true) {
                            this.cancelImport()
                            this.refreshTable()
                        } else {
                            this.loading = false
                        }
                    })
                } else {
                    this.loading = false
                }
            })
        },
        // 取消导入
        cancelImport () {
            this.modalImport = false
            this.$nextTick(() => {
                this.$refs.formImport.resetFields()
                this.formData.description = ''
                this.loading = false
            })
        }
    }
}
</script>
<style lang="less" scoped>
.ssh-key-modal {
    .form-con {
        .form-item {
            width: 325px;
        }
    }
}
</style>
